import { render, staticRenderFns } from "./ffyreport.vue?vue&type=template&id=52ffa22c&scoped=true&"
import script from "./ffyreport.vue?vue&type=script&lang=js&"
export * from "./ffyreport.vue?vue&type=script&lang=js&"
import style1 from "./ffyreport.vue?vue&type=style&index=1&id=52ffa22c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ffa22c",
  null
  
)

export default component.exports